/** Shopify CDN: Minification failed

Line 46:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 47:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 47:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 48:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 48:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 50:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 51:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 52:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 53:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 54:4 Transforming const to the configured target environment ("es5") is not supported yet
... and 15 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 31:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 32:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 32:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 33:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 33:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 35:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 36:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 37:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 38:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 39:4 Transforming const to the configured target environment ("es5") is not supported yet
... and 15 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 16:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 17:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 17:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 18:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 18:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 20:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 21:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 22:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 23:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 24:4 Transforming const to the configured target environment ("es5") is not supported yet
... and 15 more hidden warnings

**/
(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');

    const NAV_ARROWS = 'arrows';
    const NAV_PAG = 'pagination';
    const CN_AUTOPLAY = '@autoplay';
    const SP_AUTOPLAY = '--autoplay';
    const ATTR_AUTOPLAY = 'autoplay';
    const CN_NAV_DISABLED = '!disabled';
    const SEL_BG_VIDEO = 'background-video';
    const SEL_VIDEO_SLIDE = '[data-video-slide]';
    const ATTR_HAS_VIDEO = 'has-video';
    const ATTR_NAVIGATION = 'navigation';
    const ATTR_AUTO_HEIGHT = 'auto-height';
    
    customElements.define('slideshow-hero', class extends Core {
        elements = {
            swiper: '[data-swiper]',
            next: '[data-next]',
            prev: '[data-prev]'
        }

        render() {
            this._setSwiperProps();
            this._initSwiper();
            this._initAutoplay();
        }
        
        _initSwiper() {
            this.swiper = new Swiper(this.$swiper, this.swiperProps);
            this.hasVideo && this.swiper.on('slideChange', this._toggleVideo.bind(this));
        }

        _initAutoplay() {
            if(this.autoplay) {
                this.classList.add(CN_AUTOPLAY);
                this.style.setProperty(SP_AUTOPLAY, `${this.autoplay}ms`);
                this.swiper.on('autoplayStop', () => {
                    this.classList.remove(CN_AUTOPLAY);
                });
            }
        }

        _setSwiperProps() {
            this.swiperProps = {
                loop: true
            };
            
            this.swiperProps.autoHeight = this.autoHeight;

            if(this.hasVideo) 
                this.swiperProps.on = {
                    init: () => {
                        window.customElements.whenDefined(SEL_BG_VIDEO).then(() => {
                            this.videoSlides = Array.from(this.querySelectorAll(SEL_VIDEO_SLIDE)).map(video => {
                                video.querySelector(SEL_BG_VIDEO).initPlayer();
                                return video;
                            })
                        })
                    }
                }

            if(this.navigation == NAV_ARROWS)
                this.swiperProps.navigation = {
                    nextEl: this.$next,
                    prevEl: this.$prev,
                    disabledClass: CN_NAV_DISABLED
                }

            if(this.navigation == NAV_PAG) 
                this.swiperProps.pagination = {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                }
            
            if(this.autoplay) 
                this.swiperProps.autoplay = {
                    delay: this.autoplay
                }
        }

        _toggleVideo({ slides, activeIndex, previousIndex }) {
            const current = this.videoSlides.find((item) => item === slides[activeIndex]);
            const prev = this.videoSlides.find((item) => item === slides[previousIndex]);
            current?.querySelector(SEL_BG_VIDEO)?.play();
            prev?.querySelector(SEL_BG_VIDEO)?.pause();            
        }

        get navigation() {
            return this.getAttribute(ATTR_NAVIGATION);
        }
        get hasVideo() {
            return this.hasAttribute(ATTR_HAS_VIDEO);
        }
        get autoplay() {
            return this.getAttribute(ATTR_AUTOPLAY) && +this.getAttribute(ATTR_AUTOPLAY);
        }
        get autoHeight() {
            return this.hasAttribute(ATTR_AUTO_HEIGHT);
        }
    })
})();